import { Check } from "lucide-react";
import type { DashboardData } from "../../types";
import { money, isCard, shortName } from "../../lib/finance";
import { Private } from "../../components/Privacy";
import LoadingLabel from "../../components/LoadingLabel";

/** Shown once entries are saved, with the balance of each account they touched once it is known. */
export default function EntrySaved({ count, savedAccounts, balanceFailed }: {
  count: number;
  /** Null until the refreshed balances arrive. */
  savedAccounts: DashboardData["accounts"] | null;
  balanceFailed: boolean;
}) {
  return (
    <div className="expense-success" role="status">
      <span>
        <Check size={32} />
      </span>
      <h3>
        {count > 1
          ? `${count} entries saved.`
          : "Entry saved."}
      </h3>
      <p>Saved.</p>
      {savedAccounts === null && !balanceFailed && <p><LoadingLabel>Updating account balance</LoadingLabel></p>}
      {balanceFailed && <p>Entry saved. Account balance could not be refreshed; check Accounts.</p>}
      {savedAccounts?.map(account => <div key={account.id} className="saved-account-balance"><p>{shortName(account.name)} · {account.currency}</p><strong>{account.balance == null ? "Balance unavailable" : <Private>{money(isCard(account) && account.creditLimit != null ? account.creditLimit - account.balance : account.balance, account.currency)}</Private>}</strong><p>{isCard(account) ? (account.creditLimit != null ? "Available credit" : "Amount owed") : "Current account balance"}</p></div>)}
    </div>
  );
}
